import React from 'react';
import { FlowNode } from '../../../../types/flowBuilder';
import { BaseConfigProps, ConfigSection, ConfigField } from '../shared/ConfigFormHelpers';

interface DataSortConfigProps extends BaseConfigProps {
  node: FlowNode;
  updateConfig: (key: string, value: any) => void;
}

const DataSortConfig: React.FC<DataSortConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-4">
      <ConfigSection title="Rendezés beállítások">
        <ConfigField
          label="Rendezési mező"
          description="Melyik mező alapján rendezzen"
        >
          <input
            type="text"
            value={node.data.config?.sortBy || ''}
            onChange={(e) => updateConfig('sortBy', e.target.value)}
            placeholder="name, date, price..."
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </ConfigField>

        <ConfigField
          label="Rendezési irány"
          description="Növekvő vagy csökkenő"
        >
          <select
            value={node.data.config?.order || 'asc'}
            onChange={(e) => updateConfig('order', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            <option value="asc">Növekvő (A-Z, 0-9)</option>
            <option value="desc">Csökkenő (Z-A, 9-0)</option>
          </select>
        </ConfigField>

        <ConfigField
          label="Adattípus"
          description="A mező típusa"
        >
          <select
            value={node.data.config?.dataType || 'string'}
            onChange={(e) => updateConfig('dataType', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            <option value="string">Szöveg</option>
            <option value="number">Szám</option>
            <option value="date">Dátum</option>
            <option value="boolean">Logikai</option>
          </select>
        </ConfigField>

        <div className="flex items-center">
          <input
            type="checkbox"
            id="caseSensitive"
            checked={node.data.config?.caseSensitive || false}
            onChange={(e) => updateConfig('caseSensitive', e.target.checked)}
            className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
          />
          <label htmlFor="caseSensitive" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Kis/nagybetű érzékeny (szöveg esetén)
          </label>
        </div>
      </ConfigSection>

      <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-md p-3">
        <div className="text-xs text-green-700 dark:text-green-300">
          <strong>📊 Adatrendezés:</strong>
          <br />• Tömb elemek rendezése
          <br />• Eredmény: <code>{'{{sorted}}'}</code>
          <br />• Példa: <code>price</code> növekvő sorrendben
        </div>
      </div>
    </div>
  );
};

export default DataSortConfig;
